import { VehicleValuationType } from "@/api-schema-enums";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { InfoIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import {
  getVehicleValuationTypeHint,
  getVehicleValuationTypeLabel,
  VEHICLE_VALUATION_TYPE_VALUES,
} from "../_helpers/vehicle-valuation-metadata";

interface VehicleValuationTypeHintPopoverProps {
  values?: readonly VehicleValuationType[];
}

export function VehicleValuationTypeHintPopover({
  values = VEHICLE_VALUATION_TYPE_VALUES,
}: VehicleValuationTypeHintPopoverProps) {
  const { t } = useTranslation(["fab"]);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label={t("fab:VehicleValuationTypeHintAriaLabel")}
          className="text-muted-foreground hover:text-foreground inline-flex size-4 items-center justify-center rounded-sm transition-colors"
        >
          <InfoIcon className="size-3.5" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-88 max-w-[calc(100vw-2rem)]">
        <div className="space-y-3">
          <p className="text-sm font-semibold">{t("fab:VehicleValuationTypeHintTitle")}</p>
          <dl className="space-y-2">
            {values.map((value) => (
              <div key={value} className="grid gap-0.5">
                <dt className="text-sm font-medium">{getVehicleValuationTypeLabel(value, t)}</dt>
                <dd className="text-muted-foreground text-sm leading-relaxed">
                  {getVehicleValuationTypeHint(value, t)}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </PopoverContent>
    </Popover>
  );
}
